import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@material-ui/core'

import { isEmptyOrNil } from 'libs/empty'
import PrimaryTooltip from 'app/componentV4/Tooltip/PrimaryTooltip'

const TruncateWithTooltip = ({
  value = null,
  className = '',
  placement = 'bottom',
}) => {
  if (isEmptyOrNil(value)) return '--'

  return (
    <PrimaryTooltip title={value} placement={placement}>
      <Typography className={className}>{value}</Typography>
    </PrimaryTooltip>
  )
}

TruncateWithTooltip.propTypes = {
  value: PropTypes.string,
  className: PropTypes.string,
  placement: PropTypes.string,
}

export default TruncateWithTooltip
